import './AreasPage.scss';
import React, { useState } from "react";
import Spinner from '../../Spinner';
import { useAreasContext } from '../../../contexts/AreasContext';
import { MapPinArea } from "@phosphor-icons/react";
import MyAreas from './MyAreas';
import { useAlertsContext } from '../../../contexts/AlertsContext';
import AreasModal from './Modals/AreasModal';
import TeamAreas from './TeamAreas';

export default function AreasPage(props) {
    const {
        myAreas,
        teamAreas,
        setMyAreas,
        setTeamAreas,
        modal,
        setModal
    } = useAreasContext();


    const {
        alerts,
        setAlerts
    } = useAlertsContext();

    const { 
        setPanel, 
        panel, 
        user, 
        map
    } = props;

    const [stage, setStage] = useState('My Areas');

    const stageSwitch = (stage) => {
        switch (stage) {
            case 'My Areas':
                return (
                    <MyAreas 
                        myAreas={myAreas}
                        setMyAreas={setMyAreas}
                        panel={panel}
                        setPanel={setPanel}
                        map={map}
                        user={user}
                        alerts={alerts}
                        setAlerts={setAlerts}
                        modal={modal}
                        setModal={setModal}
                    />
                )
            case 'Team Areas':
                return (
                    <TeamAreas 
                        teamAreas={teamAreas}
                        setTeamAreas={setTeamAreas}
                        panel={panel}
                        setPanel={setPanel}
                        map={map}
                        user={user}
                        alerts={alerts}
                        setAlerts={setAlerts}
                        modal={modal}
                        setModal={setModal}
                    />
                )
        }
    }

    return (
        <div className='areas-page'>
            {(modal.type) && 
            <AreasModal 
                modal={modal} 
                setModal={setModal}
                // areas={areas}
                // setAreas={setAreas}
                // setArea={setArea}
            />}
            <div className='areas-page-title'>
                {/* <MapPinArea size={24} color="#db6300" weight="fill" /> */}
                <div className='areas-page-title-text'>Monitoring Areas</div>
            </div>
            <div className='areas-page-description'>Create and monitor custom areas for fire detection. Enable alerts to receive emails when fires are reported within your monitored areas.</div>
            {myAreas && teamAreas ?
            <div className='areas-page-content'>
                <div className='areas-page-content-tabs'>
                    {['My Areas', 'Team Areas'].map((a, index) => (
                        <div
                            key={index}
                            className='areas-page-content-tabs-tab'
                            style={{
                                borderBottom: a === stage ? '2px solid #0080ff' : ''
                            }}
                            onClick={() => setStage(a)}
                        >
                           {a}
                        </div>
                    ))}
                </div>
                {stageSwitch(stage)}
            </div>
            :
            <>
                <br></br>
                <Spinner />
            </>}
        </div>
    );
}